import { Page } from '@web/components/page';
import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';
import { ShopHomeScreen, ShopHomeScreenProps } from 'shared/screens/shop/shop-home';

export default function ShopHomePage(props: ShopHomeScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.setTitle(t('shop.shop_home.title')).setDescription(t('shop.shop_home.description'))
      }
    >
      <ShopHomeScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(ShopHomeScreen.pageBuilder);
